import '../scss/main.scss';

document.addEventListener('DOMContentLoaded', (event) => {
	const htmlEl = document.querySelector('html');
	htmlEl.classList.contains('js') ? '' : htmlEl.classList.add('js');
});

// import './flyout-navigation';
import './language-navigation';
// import './header-sticky';
// import './form-submit';
